import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import { informasiList } from './repository';
import pagination from '../DataTable/pagination';
import SearchBox from '../DataTable/SearchBox';
import { RiDeleteBin6Line, RiAddFill } from 'react-icons/ri';
import Button from 'react-bootstrap/Button';
import './table.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { BsCalendarDate } from "react-icons/bs";
import { FaRegEdit } from "react-icons/fa";
import Delete from "../Delete";
import { SettingContext } from "../../Setting/SettingContext";
import {
  gettags,
  savetags,
  deletetag,
  updatetagdata,
  getpromocodeData,
  updatepromocode,
  deletepromocode
} from "../../Api/settingApi";



const Informasi = () => {

    const [companyInfo, setCompanyInfo, companyServiceArea, setCompanyServiceArea, generalSettings, setGeneralSettings, paymenetmethod, setPaymenetmethod, emailData, setEmailData, emailTemplate, setEmailTemplate, promocodeData, setPromocodeData, zonesdata, setZonesData, smsstatus, setSmsstatus, masterpassword, setMasterpassword, searcpricestatus, setSearcpricestatus, Tagsdata, setTagData] = useContext(SettingContext);

    const [show05, setShow05] = useState(false);

    const handleClose05 = () => setShow05(false);
    const handleShow05 = () => setShow05(true);

    const [show005, setShow005] = useState(false);

    const handleClose005 = () => setShow005(false);
    const handleShow005 = () => setShow005(true);


    const [show06, setShow06] = useState(false);

    const handleClose06 = () => setShow06(false);
    const handleShow06 = () => setShow06(true);

    const [selected, setSelected] = useState([]);

    const [searchText, setSearchText] = useState('');
    const [promocodeId, setPromocodeId] = useState('');

    const [tagname, settagname] = useState('');
    const [category, setcategory] = useState('');


    const [Edittagname, setEditTagname] = useState('');
    const [Editcategory, setEditCategory] = useState('');
    const [Edittagid, setEditTagId] = useState('');
    const [Webhook, setwebhook] = useState('');
    const [Webhookvalue, setwebhookvalue] = useState('');

    const [editwebhook, seteditwebhook] = useState('');
    const [editwebhookvalue, seteditwebhookvalue] = useState('');

    const [addloader, setAddloader] = useState(false);
    const [editloader, setEditloader] = useState(false);

    // helper: http/https URL validate
    const isValidHttpUrl = (str) => {
        try {
            const u = new URL(String(str).trim());
            return /^https?:$/.test(u.protocol); // only http or https
        } catch {
            return false;
        }
    };

    const savetagdata = () => {
        setAddloader(true);
        // normalize
        const webhookOn = String(Webhook) === "1";
        const trimmedUrl = String(Webhookvalue || "").trim();

        // URL validation only when webhook is ON
        if (webhookOn) {
            if (!trimmedUrl) {
                // setWebhookError("Webhook URL required");
                alert("Please enter Webhook URL");
                setAddloader(false);
                return;
            }
            if (!isValidHttpUrl(trimmedUrl)) {
                // setWebhookError("Enter a valid URL starting with http:// or https://");
                alert("Enter a valid URL starting with http:// or https://");
                setAddloader(false);
                return;
            }
        }
        const formData = new FormData();
        formData.append('tag_name', tagname);
        formData.append('category_id', category);
        formData.append('webhook_status', Webhook);
        formData.append('webhook_value', Webhookvalue);

        savetags(formData).then((res) => {
            if (res.code === 200) {
                SearchBox();
                handleClose05();
                setAddloader(false);
                setwebhook('');
                setwebhookvalue('');
            }
        }).catch((err) => {
            console.log(err);
        });
    }


    const editagdata = () => {
        setEditloader(true);
        const formData = new FormData();
        formData.append('tag_name', Edittagname);
        formData.append('category_id', Editcategory);
        formData.append('tag_id', Edittagid);
        formData.append('webhook_status', editwebhook);
        formData.append('webhook_value', editwebhookvalue);


        updatetagdata(formData).then((res) => {
            if (res.code === 200) {
                SearchBox();
                handleClose005();
                setEditloader(false);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    const deletetagsfunc = () => {
        handleClose06();
        const formData = new FormData();
        formData.append('tag_id', Edittagid);

        deletetag(formData).then((res) => {
            if (res.code === 200) {
                SearchBox();
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const optionFormatter = (cell, row) => {
        return (
            <div className="button-group">
                <Button className="Delete-Active-bttn me-2" onClick={() => {
                    handleShow06();
                    setEditTagId(row.id)
                }}><RiDeleteBin6Line /></Button>
                <Button className="Edit-Active-bttn" onClick={() => {
                    setEditTagname(row.tag_name);
                    setEditCategory(row.category_id);
                    seteditwebhook(row.webhook_status);
                    seteditwebhookvalue(row.webhook_value);
                    setEditTagId(row.id)
                    handleShow005();
                }}><FaRegEdit /></Button>
            </div>
        );
    }

    const optionFormatterNew = (cell, row) => {
        const category_id = row?.category_id;
        return (
            <>
                {
                    category_id === '0' ? "User" : "Technician"
                }
            </>
        );
    }

    const optionFormatterwebhook = (cell, row) => {
        const webhook_status = row?.webhook_status;
        return (
            <>
                {
                    webhook_status === '0' ? "No" : "Yes"
                }
            </>
        );
    }

    const columns = [{
        dataField: 'id',
        text: 'ID',
        sort: true
    },
    {
        dataField: 'tag_name',
        text: 'Tag name',
        sort: true
    },
    {
        dataField: 'category_id',
        text: 'Category',
        sort: true,
        formatter: optionFormatterNew,
    },
    {
        dataField: 'webhook_status',
        text: 'Webhook status',
        sort: true,
        formatter: optionFormatterwebhook,
    },
    {
        dataField: 'action',
        text: 'ACTION',
        formatter: optionFormatter,
    }];

    useEffect(() => {
        SearchBox();
    }, [searchText])

    const SearchBox = () => {
        const formData = new FormData();
        formData.append('searchText', searchText);
        gettags(formData).then((res) => {
            if (res.code === 200) {
                if (res.data.status === 1) {
                    const apiResponse = res.data;
                    setTagData(apiResponse.data);
                }
                else {
                    setTagData([]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    // const deletepromocodeData = (id) => {
    //     //confiramation box
    //     if (window.confirm('Are you sure you want to delete?')) {
    //         const formData = new FormData();
    //         formData.append('id', id);

    //         deletepromocode(formData).then((res) => {
    //             if (res.code === 200) {
    //                 if (res.data.status === "success") {
    //                     SearchBox();
    //                 }
    //                 else {
    //                     setPromocodeData([]);
    //                 }
    //             }
    //         }).catch((err) => {
    //             console.log(err);
    //         });

    //     }
    // }

    // const handleEdit = (id) => {
    //     const formData = new FormData();
    //     formData.append('id', id);

    //     getpromocodeData(formData).then((res) => {
    //         if (res.code === 200) {
    //             if (res.data.status === "success") {
    //                 const apiResponse = res.data;
    //                 const data = apiResponse.data;
    //                 setPromocodeId(data.id);
    //                 setCouponcode(data.coupon_code);
    //                 setCoupantype(data.type);
    //                 setValue(data.value);
    //                 setLimit(data.limits);
    //                 setExpiry(data.expiry_date);
    //                 handleShow005();
    //             }
    //             else {
    //                 setPromocodeData([]);
    //             }
    //         }
    //     }).catch((err) => {
    //         console.log(err);
    //     });

    // }

    // const handleEditInputChange = (e) => {
    //     const { name, value } = e.target;
    //     if (name === "couponcode") {
    //         setCouponcode(value);
    //     }
    //     else if (name === "coupantype") {
    //         setCoupantype(value);
    //     }
    //     else if (name === "value") {
    //         setValue(value);
    //     }
    //     else if (name === "limit") {
    //         setLimit(value);
    //     }
    //     else if (name === "expiry") {
    //         setExpiry(value);
    //     }
    // }

    // const UpdatePromoCodeData = () => {
    //     const formData = new FormData();
    //     formData.append('id', promocodeId);
    //     formData.append('coupon_code', couponcode);
    //     formData.append('coupon_type', coupantype);
    //     formData.append('coupon_value', value);
    //     formData.append('coupon_limit', limit);
    //     formData.append('coupon_expiry_date', expiry);

    //     updatepromocode(formData).then((res) => {
    //         if (res.code === 200) {
    //             if (res.data.status === "success") {
    //                 SearchBox();
    //                 handleClose005();
    //             }
    //             else {
    //                 setPromocodeData([]);
    //             }
    //         }
    //     }).catch((err) => {
    //         console.log(err);
    //     });
    // }



    return (
        <>

            {/* New Tags modal start here */}
            <Modal show={show06} onHide={handleClose06}>
                <Modal.Header closeButton style={{ backgroundColor: '#75B317', color: '#fff' }}>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to proceed?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose06}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={deletetagsfunc}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* modal End here */}

            {/* New Tags modal start here */}
            <Modal show={show05} onHide={handleClose05} className="Sidebar-Modal-end">
                <Modal.Header closeButton>
                    <Modal.Title>Create New Tags</Modal.Title>
                </Modal.Header>
                <Modal.Body className='custum-modal-body'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Tag Name</Form.Label>
                                <Form.Control type="text" placeholder="Tag name" onChange={(e) => { settagname(e.target.value) }} />
                            </Form.Group>
                        </div>
                        <div className='col-md-12'>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Category</Form.Label>
                                <Form.Select className="custom-select-box" onChange={(e) => {
                                    setcategory(e.target.value)
                                }}>
                                    <option value=''>Select category id</option>
                                    <option value={'0'}>User</option>
                                    <option value={'1'}>Technician</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className='col-md-12'>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Send data to webhook</Form.Label>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="webhook" id="flexRadioDefault1" value="1" onChange={(e) => { setwebhook(e.target.value) }} />
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                        Yes
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="webhook" id="flexRadioDefault2" value="0" onChange={(e) => { setwebhook(e.target.value); setwebhookvalue('') }} />
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                        No
                                    </label>
                                </div>
                            </Form.Group>
                        </div>
                        {
                            Webhook === "1" &&
                            <div className='col-md-12'>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control type="url" placeholder="Webhook URL" pattern="https?://.+" onChange={(e) => { setwebhookvalue(e.target.value) }} />
                                </Form.Group>
                            </div>
                        }

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {
                        editloader ? (<button className="Active-bttn btn" disabled> Saving... </button>) : (
                            <>
                                <button className="Active-bttn btn" onClick={savetagdata}> Save </button>
                                <button className="Cancel-bttn btn" onClick={handleClose05}> Cancel </button>
                            </>
                        )
                    }
                </Modal.Footer>
            </Modal>
            {/* modal End here */}

            {/* Edit Tags modal start here */}
            <Modal show={show005} onHide={handleClose005} className="Sidebar-Modal-end">
                <Modal.Header closeButton>
                    <Modal.Title>Edit tags</Modal.Title>
                </Modal.Header>
                <Modal.Body className='custum-modal-body'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Tag Name</Form.Label>
                                <Form.Control type="text" value={Edittagname || ""} name="couponcode" onChange={(e) => setEditTagname(e.target.value)} placeholder="Bedrooms" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <div className='col-md-12'>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Category</Form.Label>
                                        <Form.Select className="custom-select-box" onChange={(e) => {
                                            setEditCategory(e.target.value)
                                        }}>
                                            <option value=''>Select category id</option>
                                            <option value={'0'} selected={Editcategory === "0" ? true : false}>User</option>
                                            <option value={'1'} selected={Editcategory === "1" ? true : false}>Technician</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>

                            </Form.Group>
                            <div className='col-md-12'>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Send data to webhoook</Form.Label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="webhook" id="flexRadioDefault1" value="1" checked={editwebhook === "1" ? true : false} onChange={(e) => { seteditwebhook(e.target.value) }} />
                                        <label className="form-check-label" htmlFor="flexRadioDefault1">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="webhook" id="flexRadioDefault2" value="0" checked={editwebhook === "0" ? true : false} onChange={(e) => { seteditwebhook(e.target.value); seteditwebhookvalue('') }} />
                                        <label className="form-check-label" htmlFor="flexRadioDefault2">
                                            No
                                        </label>
                                    </div>
                                </Form.Group>
                            </div>
                            {
                                editwebhook === "1" && <div className='col-md-12'>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Control type="url" placeholder="Webhook URL" value={editwebhookvalue || ""} onChange={(e) => { seteditwebhookvalue(e.target.value) }} />
                                    </Form.Group>
                                </div>
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {
                        editloader ? (<button className="Active-bttn btn" disabled> Updating... </button>) : (
                            <>
                                <button className="Active-bttn btn" onClick={editagdata}> Update </button>
                                <button className="Cancel-bttn btn" onClick={handleClose005}> Cancel </button>
                            </>
                        )
                    }
                </Modal.Footer>
            </Modal>
            {/* modal End here */}

            <div className="animated fadeIn" >
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex table-card-header">
                                <Form.Group>
                                    <div className='d-flex'>
                                        <div addonType="prepend">
                                        </div>
                                        <Form.Control type="text" placeholder="Keywords..." onChange={
                                            (e) => {
                                                setSearchText(e.target.value)
                                            }
                                        } />
                                    </div>
                                </Form.Group>
                                <Button onClick={handleShow05} className="btn btn-sm float-right add-user-btn"> <RiAddFill /> Add New</Button>
                            </div>
                            <div className="card-body">
                                <BootstrapTable bootstrap4 keyField='id' data={Tagsdata} columns={columns} pagination={pagination} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Informasi;